import type { CustomerStatusSummary } from 'services/customerStatusService';
import type { BaseTerritoryData } from 'services/basesServices';

import {
  CUSTOMER_STATUS_FAILURE,
  CUSTOMER_STATUS_INVALIDATE,
  CUSTOMER_STATUS_REQUEST,
  CUSTOMER_STATUS_SUCCESS,
  CustomerStatusAction,
  CustomerStatusSuccessPayload,
} from '../actions/customerStatus-actions';

export type CustomerStatusState = {
  siteCode: string | null;
  fetchedAt: number | null;
  status: 'idle' | 'loading' | 'ready' | 'error';
  summary: CustomerStatusSummary | null;
  summaryFailed: boolean;
  territoryByBase: Record<string, BaseTerritoryData>;
  failedBases: string[];
};

export const initialState: CustomerStatusState = {
  siteCode: null,
  fetchedAt: null,
  status: 'idle',
  summary: null,
  summaryFailed: false,
  territoryByBase: {},
  failedBases: [],
};

const customerStatusReducer = (
  state: CustomerStatusState = initialState,
  action: CustomerStatusAction
): CustomerStatusState => {
  switch (action.type) {
    case CUSTOMER_STATUS_REQUEST: {
      const { siteCode } = action.payload as { siteCode: string };
      const changedSite =
        state.siteCode !== null && state.siteCode !== siteCode;

      return {
        ...(changedSite ? initialState : state),
        siteCode,
        status: 'loading',
      };
    }

    case CUSTOMER_STATUS_SUCCESS: {
      const payload = action.payload as CustomerStatusSuccessPayload;

      return {
        siteCode: payload.siteCode,
        fetchedAt: payload.fetchedAt,
        status: 'ready',
        summary: payload.summary,
        summaryFailed: payload.summaryFailed,
        territoryByBase: payload.territoryByBase,
        failedBases: payload.failedBases,
      };
    }

    case CUSTOMER_STATUS_FAILURE: {
      const { siteCode } = action.payload as { siteCode: string };

      return {
        ...initialState,
        siteCode,
        status: 'error',
      };
    }

    case CUSTOMER_STATUS_INVALIDATE:
      return initialState;

    default:
      return state;
  }
};

export default customerStatusReducer;
